export function TeamliveFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/teamlive-filled.svg'"></ng-include>`
    }
}